// extracted by mini-css-extract-plugin
export default {"notificationWrapper":"gA3u8","bagNotificationImage":"m-Krw","rightPanel":"zZH5i","price":"U4Ae1","message":"_4J81u"};